<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('任务名称')">
              <j-input :placeholder="$t('任务名称模糊查询')" v-model="queryParam.taskName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('任务类型')">
              <a-select :placeholder="$t('请选择')" v-model="queryParam.taskType">
                <a-select-option v-for="(item,value) in taskTypeObj" :value="value" :key="value">{{item}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('任务状态')">
              <a-select :placeholder="$t('请选择')" v-model="queryParam.taskState">
                <a-select-option v-for="(item,value) in taskStateObj" :value="value" :key="value">{{item}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="downloadFormWork(1)">{{ $t('下载批量报装模板') }}</a-button>
      <a-button type="primary" icon="download" @click="downloadFormWork(2)">{{ $t('下载批量建档模板') }}</a-button>
      <a-button type="primary" icon="download" @click="downloadFormWork(3)">{{ $t('下载批量激活模板') }}</a-button>
      <a-button type="primary" icon="download" @click="downloadFormWork(4)">{{ $t('下载批量更新经纬度模板') }}</a-button>
      <a-button type="primary" icon="download" @click="downloadFormWork(5)">{{ $t('下载批量删除模板') }}</a-button>
      <a-button type="primary" icon="download" @click="downloadFormWork(9)">{{ $t('下载批量更新册号模板') }}</a-button>
      <a-button type="primary" icon="download" @click="handleCreateTask()">{{ $t('创建任务') }}</a-button>
      <a-button type="primary" icon="download" @click="downloadFormWork(10)">{{ $t('下载一键激活模板') }}</a-button>
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="taskState" slot-scope="text, record">
          <label :class="record.taskState === 1?'doing-status':record.taskState === 2?'finish-status':'wait-status'">
            {{taskStateObj[record.taskState]?taskStateObj[record.taskState]:$t('未知')}}
          </label>
        </span>
        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)">编辑</a> -->
          <a @click="handleDetail(record)">{{ $t('查看结果') }}</a>
        </span>

      </a-table>
    </div>
    <meter-batch-task-modal ref="meterBatchTaskModal" @ok="modalFormOk"></meter-batch-task-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { isNull,isUndefined } from '@/utils/validate'
  import meterBatchTaskModal from './modules/meterBatchTaskModal'
  import { downFile } from '@/api/manage'
  import {fileUrl} from'@/utils/util'
  import JInput from '@/components/jeecg/JInput'

  export default {
    name: 'MeterBatchTaskRecordList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      meterBatchTaskModal,
      JInput
    },
    data () {
      return {
        description: 'meter_batch_task_record管理页面',
        url: {
          list: "/jeecg-charge/meter/meterBatchTaskRecord/list",
          delete: "/jeecg-charge/meter/meterBatchTaskRecord/delete",
          deleteBatch: "/jeecg-charge/meter/meterBatchTaskRecord/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterBatchTaskRecord/exportXls",
          importExcelUrl: "jeecg-charge/meter/meterBatchTaskRecord/importExcel",
          errorfileDownload: "/jeecg-charge/meter/meterBatchTaskRecord/errorfile_download",
          meterFileUrl:'/file/批量报装模板.xls',
          userFileUrl: '/file/user_model.xls',
          userActivateFileUrl: '/file/user_model_activate.xls',
          meterLngLatFileUrl: '/file/meter_model_lnglat.xls',
          commandModelFileUsr: '/file/common_model.xls',
          meterVolumeNoFileUrl: '/file/meter_model_volumeno.xls',
          activation: '/file/一键激活模板.xls',
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：选项值映射使用 computed 以响应语言切换
      taskStateObj() {
        return {"0": this.$t('待执行'),"1": this.$t('执行中'),"2": this.$t('执行完成'),"3": this.$t('取消')}
      },
      taskTypeObj() {
        return {1: this.$t('批量报装'),2: this.$t('批量建档'),3: this.$t('批量激活'),4: this.$t('批量删除'),5: this.$t('批量命令'),6: this.$t('批量更新经纬度'),7: this.$t('收费对账'),8: this.$t('批量调价'),9: this.$t('批量更新册号'),10: this.$t('批量一键激活'),11: this.$t('批量更新出厂日期'),12: this.$t('微信对账')}
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('任务名称'),
            align:"center",
            dataIndex: 'taskName'
          },
          {
            title: this.$t('任务操作类型'),
            align:"center",
            dataIndex: 'taskType',
            customRender:(t,r,index) => {
              if(isUndefined(this.taskTypeObj[t])) {
                return this.$t('未知')
              }
              return this.taskTypeObj[t]
            }
          },
          {
            title: this.$t('文件名称'),
            align:"center",
            dataIndex: 'taskFileName',
            customRender:function (t,r,index) {
              if(t==null||t==='') {
                return "--"
              }
              return t
            }
          },
          /*
          {
            title:'任务文件路径',
            align:"center",
            dataIndex: 'taskFilePath'
          },
          */
          {
            title: this.$t('任务状态'),
            align:"center",
            dataIndex: 'taskState',
            /*
            customRender:function (t,r,index) {
              if(isUndefined(this.taskStateObj[t])) {
                return this.$t('未知')
              }
              return this.taskStateObj[t]
            },
            */
            scopedSlots: { customRender: 'taskState' },
          },
          {
            title: this.$t('执行成功记录数'),
            align:"center",
            dataIndex: 'taskSuccessCount'
          },
          {
            title: this.$t('任务总记录数'),
            align:"center",
            dataIndex: 'taskTotalCount'
          },
          {
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark'
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:80,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      },
      handleCreateTask() {
        this.$refs.meterBatchTaskModal.add()
      },
      handleDetail(record) {
        if(record.taskState==null||record.taskState!==2) {
          this.$message.error(this.$t("请等待任务执行成功后查询执行结果!"));
          return ;
        }
        this.handleExporTxt(this.url.errorfileDownload,this.$t('查看任务{name}的执行结果', { name: record.taskName }),{id: record.id})
      },
      handleExporTxt(url,fileName,params){
        if(!fileName || typeof fileName != "string"){
          fileName = this.$t("导出文件")
        }
        downFile(url,params).then((data)=>{
          if (!data) {
            this.$message.warning(this.$t("文件下载失败"))
            return
          }
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
          }else{
            let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName+'.txt')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          }
        })
      },
      handleExportXls(url,fileName){
        if(!fileName || typeof fileName != "string"){
          fileName = this.$t("导出文件")
        }
        url = `${fileUrl}${url}`
        console.log(url)
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', fileName+'.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
      },
      downloadFormWork(type) {
        console.log("下载模板")
        // 下载模板
        let titleObj = {1: this.$t('批量报装模板'),2: this.$t('批量建档模板'),3: this.$t('批量激活模板'),4: this.$t('批量更新经纬度模板'),5: this.$t('批量删除'),9: this.$t('批量更新册号'),10: this.$t('一键激活模板')}
        let urlObj = {1: this.url.meterFileUrl,2: this.url.userFileUrl,3: this.url.userActivateFileUrl,4: this.url.meterLngLatFileUrl,5: this.url.commandModelFileUsr,9: this.url.meterVolumeNoFileUrl,10: this.url.activation}
        let url = urlObj[type]
        this.handleExportXls(url,titleObj[type])
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>